import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import QBHeader from "./QBHeader";
import {
  loadOptionGroups,
  loadQuestionDetails,
} from "../../Redux/actions/questionAction";

import QuestionPicker from "./QuestionPicker/QuestionPicker";
import { Backdrop } from "@mui/material";
import { resetQuestionState } from "../../Redux/reducers/questionSlice";
import QuestionPropertiesModalWrapper from "./QuestionProperties/QuestionPropertiesModalWrapper";
import { QBArea } from "./question.style";
import DropAreaNew from "./DropArea/DropAreaNew";
import Loader from "../Common/assets/Loader";

type props = {
  studyId?: string;
  formId: string;
  type: "platform" | "study";
};

const QuestionBuilder = ({ studyId, formId, type }: props) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.question.loading);
  const toggle = useAppSelector((state) => state.question.toggleForm);

  useEffect(() => {
    if (formId && type) {
      dispatch(loadQuestionDetails(studyId, formId, type));
      if (type === "study" && studyId) dispatch(loadOptionGroups(studyId));
    }
    return () => {
      dispatch(resetQuestionState());
    };
  }, [dispatch, studyId, formId, toggle, type]);

  return (
    <div className="preview-wrapper">
      {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )}

      <QBHeader />
      <QBArea>
        <QuestionPicker />
        <DropAreaNew />
        <QuestionPropertiesModalWrapper />
      </QBArea>
    </div>
  );
};

export default QuestionBuilder;
